<!--
  File : Login.vue
-->

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-card class="ma-3 elevation-0" width="400">
        <v-toolbar class="elevation-0" color="white">
          <v-toolbar-title class="primary--text">운영자 로그인</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              id="email"
              prepend-icon="mdi-account"
              type="email"
              label="아이디"
              @keyup.13.stop.prevent="next('password')"
              v-model="email"
            />
            <v-text-field
              id="password"
              prepend-icon="mdi-lock"
              type="password"
              label="비밀번호"
              @keyup.13.stop.prevent="next()"
              v-model="password"
            />
          </v-form>
        </v-card-text>
        <v-row class="pl-5">
          <v-col><v-checkbox v-model="save" @change="onSave()" label="비밀번호 저장" /></v-col>
        </v-row>
        <v-card-actions>
          <v-col class="text-left" cols="8">
            <a @click="signUp()">회원가입</a><span class="ma-3">|</span><a @click="find()">비밀번호찾기</a>
          </v-col>
          <v-col class="text-right">
            <v-btn color="primary" elevation="0" @click.prevent="login()">로그인</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  data () {
    return {
      email: localStorage.getItem('email'),
      password: localStorage.getItem('password'),
      save: localStorage.getItem('password')
    }
  },

  props: {
    source: String,
  },

  methods: {
    onSave: function () {
      if (!this.save) {
        this.password = ''
        localStorage.setItem('password', '')
      }
    },

    next: function (type) {
      if (type == 'password' && this.email.length >= 3) {
        document.getElementById('password').focus()
      }
      else if (this.password.length >= 6) {
        this.login()
      }
    },

    login: function () {
      if (this.email.length < 3) {
        document.getElementById('email').focus()
        return
      }
      if (this.password.length < 6) {
        document.getElementById('password').focus()
        return
      }
      let params = new URLSearchParams()
      params.append('email', this.email)
      params.append('password', this.password)
      axios.post('/api/user/login', params, util.headers)
      .then(response => {
        if (response.data.error) {
          if (response.data.error == 'Not found' || response.data.error == 'Wrong password') {
            alert('등록되지 않은 아이디 또는 틀린 비밀번호입니다.')
          }
          else {
            console.log(response.data.error)
          }
        }
        else if (response.data.user.level < 5) {
          alert(response.data.user.name + '님은 시스템 관리자 또는 스튜디오 운영자가 아닙니다.')
        }
        else {
          let user = response.data.user
          util.getStudios((studios, error) => {
            if (error) console.log(error)
            user.studio_name = util.getItem(studios, user.studio).text
            localStorage.setItem('login', JSON.stringify(user))
            this.$emit('login', user)
            this.$router.push('/')
          })
          
          localStorage.setItem('email', user.email)
          if (this.save) {
            localStorage.setItem('password', user.password)
          }
        }
      })
    },

    signUp: function () {
      this.$router.push('/signup')
    },

    find: function () {
      this.$router.push('/password')
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json && JSON.parse(json)) {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
</style>
